
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vivienda/[...id]",
      function () {
        return require("private-next-pages/vivienda/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vivienda/[...id]"])
      });
    }
  